<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return { taskList: [{ taskId: "Activity_1h8leq4", taskName: "措施审批" }] };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
